import MuiPopper, { PopperProps as Props } from '@material-ui/core/Popper'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

export type PopperProps = Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.palette.common.white,
      boxShadow: theme.shadows[1],
      borderRadius: theme.spacing(1),
      position: 'relative'
    },
    closeIcon: {
      position: 'absolute',
      right: 0
    },
    arow: {
      position: 'absolute',
      right: '-12px',
      top: '47%',
      color: theme.palette.common.white
    }
  })
)

export const PopperVisitDetail: React.FC<PopperProps> = (props) => {
  const classes = useStyles()
  const { children, ...rest } = props
  return (
    <MuiPopper {...rest} className={classes.root}>
      {children}
    </MuiPopper>
  )
}